import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import ElementUI from 'element-ui';
import _ from 'lodash';
import moment from 'moment';
import VueEcho from 'vue-echo';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import VueI18n from 'vue-i18n';
import Viewer from 'v-viewer';
import md5 from 'js-md5';

import 'bootstrap/dist/css/bootstrap.min.css';

/* eslint camelcase: 0 */
import { zh_CN, zh_HK, zh_MO, zh_TW, en, ja, fr, de, ko, th } from './i18n';
/* eslint-disable-next-line */
import { formatMoney, getLocale } from './plugins/helpers';
import App from './App.vue';
import router from './router';
import store from './store';
import ApiPlugin from './api/plugin';
import AppConfig from './app.config';

/* globals location,navigator */

import './styles/element.scss';
import './styles/styles.scss';

window.Pusher = Pusher;

const {
  API_STANDARDS_TREE,
  APP_NAME,
  API_VERSION,
  SECRET_KEY,
} = AppConfig;
const TOKEN_EXPIRE_NOTICE_KEY = 'token_expire_at_minutes';

Vue.use(VueAxios, axios);
Vue.use(ElementUI, { zIndex: 10000 });
Vue.use(VueI18n);
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
    toolbar: false,
    title: false,
    movable: false,
  },
});

// 語言包
const locale = localStorage.getItem('language') || getLocale();
// const locale = 'zh_HK';
const i18n = new VueI18n({
  locale,
  messages: {
    zh_CN, zh_HK, zh_MO, zh_TW, en, ja, fr, de, ko, th,
  },
});
switch (locale) {
  case 'zh_HK':
    moment.locale('zh-hk');
    break;
  case 'zh_CN':
    moment.locale('zh-cn');
    break;
  case 'en':
  default:
    moment.locale(locale);
    break;
}


Vue.use(ApiPlugin);

Vue.config.productionTip = process.env.NODE_ENV !== 'production';

// 全局過濾器
Vue.filter('number', value => _.toNumber(value));
Vue.filter('currency', (value, currency, notPrecision) => formatMoney(value, currency, notPrecision));

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  watch: {
    '$store.state.user.token': {
      handler(val) {
        const auth = {
          headers: {
            Accept: `application/${API_STANDARDS_TREE}.${APP_NAME}.${API_VERSION}+json`,
          },
        };
        if (val) {
          auth.headers.Authorization = `Bearer ${val}`;
          // console.log(val);
        }
        // console.log('ECho 1111111');

        const EchoInstance = new Echo({
          broadcaster: 'pusher',
          key: AppConfig.PUSHER_CONFIG.key,
          cluster: AppConfig.PUSHER_CONFIG.cluster,
          encrypted: true,
          authEndpoint: `${AppConfig.API_HOST}/broadcasting/auth`,
          auth,
        });
        Vue.use(VueEcho, EchoInstance);
      },
      immediate: true,
    },
  },
  beforeCreate() {
    // 檢查API版本號
    this.$api.app.version().then(({ data: version }) => {
      const currentVersion = window.localStorage.getItem('API_VERSION');
      if (currentVersion !== version) {
        localStorage.setItem('API_VERSION', version);
        if (currentVersion) {
          localStorage.setItem('refresh-cache', Date.now());
          // this.$router.go(0);
        }
      }
    });
    // 设置语言
    // console.log('local', locale);
    this.$store.dispatch('setLanguage', locale).catch(() => {});
    // 設置地區
    const region = localStorage.getItem('region');
    if (region) {
      this.$store.dispatch('setRegion', { region });
    } else {
      // this.$api.app.ipInfo().then((ipInfo) => {
      // eslint-disable-next-line
      //   const region = ipInfo.country_id === 'xx' ? 'HK' : ipInfo.country_id;
      //   this.$store.dispatch('setRegion', { region, save: true }).catch(() => {});
      // }).catch(() => {
      this.$store.dispatch('setRegion', { region: 'HK', save: false }).catch(() => {});
      // });
    }
  },
  created() {
    // axios 配置
    this.axios.defaults.headers.common.Accept = `application/${API_STANDARDS_TREE}.${APP_NAME}.${API_VERSION}+json`;
    this.axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
    this.axios.interceptors.request.use((config) => {
      /* eslint no-param-reassign: 0 */
      if (this.$store.getters.isLogined) {
        const { token, expiresTime } = this.$store.state.user;
        // 检查token是否过期
        if (expiresTime > Date.now()) {
          config.headers.Authorization = `Bearer ${token}`;
        } else {
          this.$store.dispatch('logout');
        }
      }
      const ts = Date.now();
      config.headers.Signature = md5([window.location.hostname, navigator.userAgent, ts, SECRET_KEY].join('|'));
      config.headers.ts = ts;
      config.headers.Language = this.$store.state.app.language;
      config.headers.Region = this.$store.state.app.region;
      // config.headers.Currency = this.$store.state.app.currency;

      if (this.$store.state.app.trackID) {
        config.headers['X-Track-ID'] = this.$store.state.app.trackID;
      }

      const socketId = this.$echo.socketId();
      if (socketId) {
        config.headers['X-Socket-ID'] = socketId;
      }
      return config;
    });
    this.axios.interceptors.response.use((response) => {
      // token 過期提醒
      const tokenExpireNotice = response.headers['token-expire-remaining'];
      if (tokenExpireNotice) {
        sessionStorage.setItem(TOKEN_EXPIRE_NOTICE_KEY, tokenExpireNotice);
      }
      // 设置用户和服务器时间差
      if (!this.$store.state.app.timeDiff) {
        this.$store.dispatch('setTimeDiff', ~~(Date.now() / 1000) - Number(response.headers.timestamp));
      }

      if (response.headers['x-track-id'] && response.headers['x-track-id'] !== this.$store.state.app.trackID) {
        this.$store.dispatch('setTrackId', response.headers['x-track-id']);
      }

      return response;
    }, (error) => {
      if (error.response) {
        /* eslint default-case:0 */
        switch (error.response.status) {
          case 401:
            return this.$store.dispatch('logout').then(() => {
              this.$router.push({ name: 'login' });
            });
          case 500:
            //
            break;
        }
      }
      return Promise.reject(error);
    });

    // 设置货币
    // this.$store.dispatch('setCurrency').catch(() => {});

    // 每分鐘運行的任務定時器
    /*
    setInterval(() => {
      // 檢查是否需要刷新token
      if (sessionStorage.getItem(TOKEN_EXPIRE_NOTICE_KEY)) {
        this.$store.dispatch('refreshToken').then(() => {
          sessionStorage.removeItem(TOKEN_EXPIRE_NOTICE_KEY);
        });
      }
    }, 60000);
    */
  },
}).$mount('#app');
